import { toast } from "react-toastify";

import {
  ArchiveExperienceRequestPathParamType,
  ArchiveExperienceResponseBodyType,
} from "@intelligems/ig-types/functions/experiences/archive-experience";
import { offerKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { experienceKeys } from "../queryKeys";

const unarchiveExperience = async (
  payload: ApiRequest<undefined, ArchiveExperienceRequestPathParamType>
): Promise<ArchiveExperienceResponseBodyType> => {
  const resp = await api.patch<ArchiveExperienceResponseBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/unarchive`,
    { experienceId: payload.pathParams.experienceId }
  );
  return resp.data;
};

export const useUnarchiveExperience = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["unarchiveExperience"],
    mutationFn: async (
      data: ApiRequest<undefined, ArchiveExperienceRequestPathParamType>
    ) => unarchiveExperience(data),
    onSuccess: async (data, payload) => {
      if (payload.pathParams.experienceId) {
        queryClient.setQueryData(
          experienceKeys.one(payload.pathParams.experienceId),
          {
            experience: data.experience,
          }
        );
      }

      await queryClient.invalidateQueries({
        queryKey: experienceKeys.personalizationList,
      });
      await queryClient.invalidateQueries({
        queryKey: offerKeys.all,
      });

      // Show a toast message confirming success
      toast.success("Experience Unarchived");
    },
  });
};
